import { type VariantProps, tv } from 'tailwind-variants';

import { ButtonOrLink, Heading } from '../../atoms';
import type { CommonProps } from '../../types';

import type { JSX } from 'react';

export interface BeatAppBannerProps
    extends CommonProps,
        VariantProps<typeof BeatAppBannerStyles> {
    locale: string;
    title: string;
}

export const BeatAppBannerStyles = tv({
    slots: {
        root: 'flex flex-col items-center bg-gray-500 py-10 text-center',
        buttons: 'flex gap-4',
    },
    variants: {},
});

export const BeatAppBanner = ({
    locale,
    title,
    className,
    testId = 'beat-app-banner',
    ...props
}: BeatAppBannerProps): JSX.Element => {
    const { root, buttons } = BeatAppBannerStyles();
    return (
        <div className={root({ className })} {...props} data-testid={testId}>
            <Heading as="h3">{title}</Heading>
            <div className={buttons()}>
                <ButtonOrLink href="https://apps.apple.com/us/app/be-at-venues/id6502352647">
                    <img
                        alt="be•at app App Store download"
                        src={`/assets/beat/app/apple/App_Store_${locale.toUpperCase()}.svg`}
                    />
                </ButtonOrLink>
                <ButtonOrLink href="https://play.google.com/store/apps/dev?id=8627460697172570338&pli=1">
                    <img
                        alt="be•at app Google Play download"
                        className="h-10"
                        src={`/assets/beat/app/android/Google_Play_${locale.toUpperCase()}.png`}
                    />
                </ButtonOrLink>
            </div>
        </div>
    );
};
